import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

import updateLearnerProgress from "../graph-ql/updateLearnerProgress.graphql";

const useMutationUpdateLearnerProgress = (opts?: MutationHookOptions) =>
  useMutation(updateLearnerProgress, opts);

export default useMutationUpdateLearnerProgress;
